





























import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import Login from '@/components/Login.vue'
import navigate from '../libs/navigate'

@Component({
  components: {
    Login
  },
  methods: {
    ...mapActions('Referrals', ['fetchCount']),
    navigate
  },
  computed: {
    ...mapGetters('Auth', { user: 'getUser' }),
    ...mapGetters('Auth', ['isAuthenticated', 'authStatus']),
    ...mapGetters('Referrals', { count: 'getCount' })
  }
})
export default class Home extends Vue {
  isAuthenticated!: boolean // from the mapGetters above
  authStatus!: string
  fetchCount!: () => void

  created () {
    if (this.isAuthenticated) { this.fetchCount() }
  }

  loading () {
    return this.authStatus === 'loading' && !this.isAuthenticated
  }
}
